import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  position: absolute;
  width: 72%;
  height: auto;
  bottom: 54%;
  left: 2%;

  .cls-1 {
    fill: #fff;
  }

  .cls-2 {
    fill: ${({ $fill }) => $fill};
  }
`;

const Eyes = ({ fill, className }) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width="236.968"
      height="116.77"
      viewBox="0 0 236.968 116.77"
      $fill={fill}
      className={className}
    >
      <g
        id="eye_woman_2"
        data-name="eye woman 2"
        transform="translate(-217.722 -279.113)"
      >
        <g id="Group_453" data-name="Group 453">
          <g id="Group_435" data-name="Group 435">
            <g id="Group_432" data-name="Group 432">
              <ellipse
                id="Ellipse_65"
                data-name="Ellipse 65"
                className="cls-1"
                cx="42.677"
                cy="45.728"
                rx="42.677"
                ry="45.728"
                transform="translate(353.102 295.446)"
              />
            </g>
            <g id="Group_433" data-name="Group 433">
              <ellipse
                id="Ellipse_66"
                data-name="Ellipse 66"
                className="cls-2"
                cx="29.424"
                cy="35.5"
                rx="29.424"
                ry="35.5"
                transform="translate(375.905 309.072)"
              />
              <path
                id="Path_445"
                data-name="Path 445"
                d="M405.329,381.071c-16.775,0-30.424-16.374-30.424-36.5s13.649-36.5,30.424-36.5,30.425,16.374,30.425,36.5S422.105,381.071,405.329,381.071Zm0-71c-15.673,0-28.424,15.476-28.424,34.5s12.751,34.5,28.424,34.5,28.425-15.476,28.425-34.5S421,310.072,405.329,310.072Z"
              />
            </g>
            <g id="Group_434" data-name="Group 434">
              <ellipse
                id="Ellipse_67"
                data-name="Ellipse 67"
                className="cls-1"
                cx="36.188"
                cy="43.103"
                rx="36.188"
                ry="43.103"
                transform="translate(228.115 304.532)"
              />
            </g>
          </g>
          <g id="Group_452" data-name="Group 452">
            <g id="Group_437" data-name="Group 437">
              <g id="Group_436" data-name="Group 436">
                <path
                  id="Path_446"
                  data-name="Path 446"
                  d="M421.713,290.014c-.125.178-1.082-.2-2.679-1.039-.8-.411-1.747-.989-2.889-1.522-.559-.291-1.172-.57-1.825-.859-.643-.307-1.344-.584-2.075-.88a48.186,48.186,0,0,0-4.876-1.653,49.025,49.025,0,0,0-5.752-1.244,46.872,46.872,0,0,0-6.462-.524,42.961,42.961,0,0,0-6.927.445,44.905,44.905,0,0,0-12.8,3.889,44.151,44.151,0,0,0-5.156,2.845c-1.574.974-2.95,2.02-4.207,2.979l-1.74,1.438-1.509,1.345c-.918.867-1.708,1.624-2.334,2.267-.652.62-1.121,1.139-1.491,1.455s-.6.463-.679.4-.018-.319.188-.763a13.334,13.334,0,0,1,1.054-1.848,30.506,30.506,0,0,1,2-2.708c.422-.5.894-1.024,1.39-1.584.513-.542,1.073-1.1,1.664-1.684a42.775,42.775,0,0,1,4.19-3.468,40.649,40.649,0,0,1,5.321-3.3,41.1,41.1,0,0,1,6.385-2.723,42.993,42.993,0,0,1,7.268-1.725,41.716,41.716,0,0,1,7.454-.42,43.094,43.094,0,0,1,12.952,2.371,39.776,39.776,0,0,1,5.013,2.126c.74.379,1.442.742,2.079,1.136.647.376,1.248.742,1.787,1.122a27.307,27.307,0,0,1,2.669,2.03C421.132,289.1,421.838,289.836,421.713,290.014Z"
                />
              </g>
            </g>
            <g id="Group_439" data-name="Group 439">
              <g id="Group_438" data-name="Group 438">
                <path
                  id="Path_447"
                  data-name="Path 447"
                  d="M290.862,304.052c-.056.05-.242-.041-.546-.256s-.706-.574-1.257-1-1.192-.965-1.977-1.546-1.684-1.227-2.715-1.881-2.189-1.321-3.458-1.982a40.983,40.983,0,0,0-4.18-1.817,37.107,37.107,0,0,0-4.818-1.418,35,35,0,0,0-10.7-.739,37.152,37.152,0,0,0-4.968.739,41.667,41.667,0,0,0-4.394,1.223c-1.348.479-2.594.969-3.7,1.488s-2.1,1.021-2.95,1.492-1.578.9-2.171,1.263c-.6.342-1.043.654-1.377.822s-.52.246-.564.193.064-.223.311-.5a12.225,12.225,0,0,1,1.16-1.147,23.743,23.743,0,0,1,2.022-1.606,29.214,29.214,0,0,1,2.9-1.833,35.388,35.388,0,0,1,3.755-1.811,35.954,35.954,0,0,1,4.559-1.494,34.791,34.791,0,0,1,5.232-.919,33.784,33.784,0,0,1,11.365.775,34.81,34.81,0,0,1,5.062,1.618,36.294,36.294,0,0,1,4.317,2.1,34.673,34.673,0,0,1,3.477,2.3,29.8,29.8,0,0,1,2.623,2.212,23.56,23.56,0,0,1,1.785,1.868,11.289,11.289,0,0,1,.987,1.3C290.838,303.814,290.917,304,290.862,304.052Z"
                />
              </g>
            </g>
            <g id="Group_440" data-name="Group 440">
              <path
                id="Path_448"
                data-name="Path 448"
                d="M395.394,387.922c-24.36,0-44.178-21.187-44.178-47.228s19.818-47.228,44.178-47.228,44.176,21.186,44.176,47.228S419.753,387.922,395.394,387.922Zm0-91.456c-22.706,0-41.178,19.841-41.178,44.228s18.472,44.228,41.178,44.228,41.176-19.841,41.176-44.228S418.1,296.466,395.394,296.466Z"
              />
            </g>
            <g id="Group_441" data-name="Group 441">
              <path
                id="Path_449"
                data-name="Path 449"
                d="M404.943,380.592c-16.775,0-30.423-16.374-30.423-36.5s13.648-36.5,30.423-36.5,30.424,16.374,30.424,36.5S421.719,380.592,404.943,380.592Zm0-71c-15.672,0-28.423,15.476-28.423,34.5s12.751,34.5,28.423,34.5,28.424-15.477,28.424-34.5S420.616,309.592,404.943,309.592Z"
              />
            </g>
            <g id="Group_442" data-name="Group 442">
              <path
                id="Path_450"
                data-name="Path 450"
                d="M263.917,391.759c-20.781,0-37.688-20.009-37.688-44.6s16.907-44.6,37.688-44.6,37.688,20.009,37.688,44.6S284.7,391.759,263.917,391.759Zm0-86.207c-19.127,0-34.688,18.663-34.688,41.6s15.561,41.6,34.688,41.6,34.688-18.663,34.688-41.6S283.044,305.552,263.917,305.552Z"
              />
            </g>
            <g id="Group_445" data-name="Group 445">
              <g id="Group_443" data-name="Group 443">
                <ellipse
                  id="Ellipse_68"
                  data-name="Ellipse 68"
                  className="cls-2"
                  cx="24.95"
                  cy="33.462"
                  rx="24.95"
                  ry="33.462"
                  transform="translate(247.065 316.896)"
                />
                <path
                  id="Path_451"
                  data-name="Path 451"
                  d="M272.015,384.821c-14.309,0-25.95-15.46-25.95-34.463s11.641-34.462,25.95-34.462,25.95,15.46,25.95,34.462S286.324,384.821,272.015,384.821Zm0-66.925c-13.206,0-23.95,14.562-23.95,32.462s10.744,32.463,23.95,32.463,23.95-14.562,23.95-32.463S285.221,317.9,272.015,317.9Z"
                />
              </g>
              <g id="Group_444" data-name="Group 444">
                <path
                  id="Path_452"
                  data-name="Path 452"
                  d="M272.015,384.821c-14.309,0-25.95-15.46-25.95-34.463s11.641-34.462,25.95-34.462,25.95,15.46,25.95,34.462S286.324,384.821,272.015,384.821Zm0-66.925c-13.206,0-23.95,14.562-23.95,32.462s10.744,32.463,23.95,32.463,23.95-14.562,23.95-32.463S285.221,317.9,272.015,317.9Z"
                />
              </g>
            </g>
            <g id="Group_447" data-name="Group 447">
              <g id="Group_446" data-name="Group 446">
                <path
                  id="Path_453"
                  data-name="Path 453"
                  d="M447.018,318.668c.251.131.342.651.127,1.529a8.747,8.747,0,0,1-1.944,3.377,12.881,12.881,0,0,1-2.166,1.919l-.69.449c-.241.142-.474.274-.84.457a15.634,15.634,0,0,1-2.216.827,19.629,19.629,0,0,1-2.506.48l-1.373.175q-.366-.543-.744-1.1c-.995-1.364-2.256-3.709-2.773-4.433-1.4-2.167-3-4.471-4.825-6.8a55.756,55.756,0,0,0-6.3-6.838,38.043,38.043,0,0,0-8.071-5.733,34.4,34.4,0,0,0-9.881-3.381,39.487,39.487,0,0,0-10.6-.41,41.058,41.058,0,0,0-9.74,2.129,42.762,42.762,0,0,0-8.112,4.031,69.83,69.83,0,0,0-6.578,4.914c-1.917,1.679-3.642,3.256-5.1,4.72-1.474,1.447-2.722,2.74-3.766,3.792-2.081,2.112-3.331,3.271-3.81,3.006s-.141-2.01,1.154-4.829A39.908,39.908,0,0,1,359,312.012a56.432,56.432,0,0,1,4.493-6.035,52.666,52.666,0,0,1,6.671-6.449,43.407,43.407,0,0,1,34.187-8.588,39.669,39.669,0,0,1,12.48,4.431,41.773,41.773,0,0,1,9.634,7.47,52.309,52.309,0,0,1,6.642,8.437,63.251,63.251,0,0,1,4.343,8.06,7.742,7.742,0,0,1,.775,2.186c.032.13.065.258.1.384l.3.072a4.063,4.063,0,0,0,.65.067,5.308,5.308,0,0,0,.7-.035,4.134,4.134,0,0,0,.494-.111l.556-.172a14.653,14.653,0,0,0,1.957-.843,26.932,26.932,0,0,0,2.665-1.7C446.312,318.764,446.745,318.524,447.018,318.668Z"
                />
              </g>
            </g>
            <g id="Group_449" data-name="Group 449">
              <g id="Group_448" data-name="Group 448">
                <path
                  id="Path_454"
                  data-name="Path 454"
                  d="M297.99,331.208c-.278.093-.688-.179-1.22-.758s-1.135-1.483-1.96-2.6c-.386-.568-.818-1.191-1.324-1.848-.483-.669-1-1.393-1.607-2.131a56.093,56.093,0,0,0-4.2-4.827,45.812,45.812,0,0,0-5.743-4.958,28.186,28.186,0,0,0-7.212-3.914l-.951-.3-.924-.207c-.681-.133-1.53-.232-2.3-.358-.788-.146-1.582-.187-2.383-.258l-1.2-.108-1.208-.021a31.6,31.6,0,0,0-9.686,1.2c-.9.212-1.728.6-2.588.885-.817.386-1.664.7-2.439,1.149a30.369,30.369,0,0,0-4.459,2.872,37.61,37.61,0,0,0-3.847,3.518,42.407,42.407,0,0,0-3.272,3.889,62.33,62.33,0,0,0-5.071,8.057c-.7,1.322-1.348,2.613-1.952,3.864l-.88,1.849-.606,1.372c-.223.473-.467.944-.7,1.39a5.8,5.8,0,0,1-1.459,1.6,5.569,5.569,0,0,1-.914.509,4.318,4.318,0,0,1-1,.217,6.276,6.276,0,0,1-3.631-.885,13.189,13.189,0,0,1-1.44-.971c-.207-.166-.456-.334-.606-.487l-.418-.4a17.6,17.6,0,0,1-1.349-1.495c-1.475-1.872-1.95-3.116-1.618-3.459.348-.362,1.557.184,3.5,1.223.485.255,1.017.537,1.591.813l.435.208a2.63,2.63,0,0,0,.31.107c.19.065.385.107.571.151a2,2,0,0,0,1.111-.035c.383-.122.558-.615.59-1.014a8.188,8.188,0,0,1,.146-.877l.6-2.054c.436-1.412.943-2.9,1.532-4.434a54.7,54.7,0,0,1,4.843-9.657,43.968,43.968,0,0,1,3.6-4.906,41.1,41.1,0,0,1,4.6-4.62,35.809,35.809,0,0,1,5.7-3.913c1.016-.6,2.127-1.061,3.214-1.571a35.453,35.453,0,0,1,3.426-1.21,36.914,36.914,0,0,1,12.484-1.426l1.495.078,1.46.177c.968.121,1.931.221,2.852.43.946.2,1.808.338,2.787.583l1.535.446c.483.174.945.365,1.412.549.938.363,1.758.826,2.6,1.25.785.481,1.6.91,2.315,1.429.726.5,1.448.99,2.1,1.53.667.522,1.311,1.044,1.9,1.6a41.167,41.167,0,0,1,5.929,6.632,38.538,38.538,0,0,1,3.636,6.261,24.908,24.908,0,0,1,1.115,2.733,17.974,17.974,0,0,1,.722,2.367,13.081,13.081,0,0,1,.491,3.406C298.406,330.658,298.268,331.115,297.99,331.208Z"
                />
              </g>
            </g>
            <g id="Group_451" data-name="Group 451">
              <g id="Group_450" data-name="Group 450">
                <path
                  id="Path_455"
                  data-name="Path 455"
                  d="M454.69,373.708c-.021.285-1,.523-2.723.716-.431.048-.909.091-1.431.128l-1.7.185c-1.213.136-2.591.2-4.105.429l-2.373.283c-.824.1-1.675.264-2.558.394-1.77.235-3.636.645-5.6,1.02-.983.191-1.974.466-2.995.7l-1.545.363-1.557.444c-2.107.549-4.239,1.279-6.435,1.991-2.158.815-4.279,1.577-6.268,2.466l-1.494.624-1.434.68c-.943.456-1.89.86-2.777,1.324-1.771.935-3.485,1.78-5.015,2.7-.771.451-1.539.853-2.244,1.292l-2.031,1.264c-1.323.77-2.441,1.58-3.475,2.231s-1.91,1.239-2.63,1.719c-1.462.935-2.359,1.376-2.546,1.175s.357-1.026,1.5-2.381a24.616,24.616,0,0,1,2.226-2.324c.914-.858,1.942-1.862,3.191-2.829l1.945-1.548c.682-.531,1.433-1.024,2.194-1.562,1.51-1.1,3.227-2.109,5.025-3.192.9-.538,1.869-1.011,2.837-1.532l1.477-.772,1.544-.707c2.064-.989,4.281-1.824,6.55-2.682,2.3-.754,4.557-1.492,6.784-2.016l1.647-.419,1.634-.327c1.081-.2,2.13-.441,3.17-.588,2.081-.285,4.053-.575,5.918-.665.931-.058,1.826-.145,2.69-.158l2.487-.012c1.58-.032,3.011.111,4.261.2a22.971,22.971,0,0,1,3.192.428C453.771,373.1,454.71,373.423,454.69,373.708Z"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="Group_454" data-name="Group 454">
          <ellipse
            id="Ellipse_69"
            data-name="Ellipse 69"
            className="cls-1"
            cx="12.458"
            cy="8.791"
            rx="12.458"
            ry="8.791"
            transform="matrix(0.9, -0.437, 0.437, 0.9, 382.896, 324.507)"
          />
        </g>
        <g id="Group_455" data-name="Group 455">
          <ellipse
            id="Ellipse_70"
            data-name="Ellipse 70"
            className="cls-1"
            cx="9.759"
            cy="6.886"
            rx="9.759"
            ry="6.886"
            transform="matrix(0.9, -0.437, 0.437, 0.9, 254.187, 331.258)"
          />
        </g>
      </g>
    </StyledSvg>
  );
};

Eyes.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string
};

export default React.memo(
  Eyes,
  (prevProps, nextProps) => prevProps.fill === nextProps.fill
);
